// Shared between AlgorithmicLeaderboard.tsx and anything else surfacing
// finV3.ranges data (e.g. trade/components/Header.tsx's top-APR promo) so
// what counts as a "real, currently visible" position stays in one place.

// apr / spread / fee are carried as 1e12 fixed-point fractions -> percent.
export const FRACTION = 1e10;
// valueUsd is carried as a 1e8 fixed-point USD amount.
export const USD = 1e8;

// Default-view floors AlgorithmicLeaderboard applies to its OPEN status view
// — without them a brand-new or dust-sized position can post a real but not
// actually-visible-by-default APR.
export const MIN_AGE_DAYS = 7;
export const MIN_VALUE_USD = 100;
export const MIN_VALUE_USD_SCALED = MIN_VALUE_USD * USD;

// The API occasionally returns corrupt ages (observed up to ~9e12 days despite
// the Int! days schema type). Anything above this cap is treated as missing so
// a single bad row can't blow out the age slider domain.
export const MAX_PLAUSIBLE_AGE_DAYS = 3650;

// APR can blow out to absurd values for very young/tiny positions (a small
// gain annualized over a few days) or from corrupt upstream data. Clamping to
// this band keeps sort/filter domains — and anything else reading this field
// — bounded to a fixed, realistic range no matter what's in the current page
// of data.
export const MIN_PLAUSIBLE_APR = -100;
export const MAX_PLAUSIBLE_APR = 1000;
